import { IntlShape } from 'react-intl'

// ufinet-web-functions' downloadXLS success toast (COUNTRY.AREA.DOWNLOAD.SUCCESS) joins the raw
// country/area ids sent to the backend directly into the message, showing GUIDs instead of names.
// This wraps `formatMessage` to swap in the matching display names for that one message only,
// without changing what's actually sent to the backend.
export const withDownloadNotificationNames = (intl: IntlShape, idToName: Map<string, string>): IntlShape => {
	if (idToName.size === 0) return intl

	// Fragile coupling: relies on ufinet-web-functions joining ids with exactly ', ' (see successNotifications.downloadXLS).
	// If that separator ever changes (e.g. locale-aware Intl.ListFormat), this falls back to returning the string untouched.
	const replaceIds = (value: string) =>
		value
			.split(', ')
			.map((id) => idToName.get(id) || id)
			.join(', ')

	return {
		...intl,
		// Only called by the Costs xCostsService factories below with an object descriptor ({id, ...}), never a
		// plain string, so `descriptor?.id` is always defined here; the cast just narrows past formatMessage's
		// overloaded signature. A string descriptor would make the `if` below false and just pass through untouched.
		formatMessage: ((descriptor: { id?: string }, values?: Record<string, unknown>) => {
			if (descriptor?.id === 'COUNTRY.AREA.DOWNLOAD.SUCCESS' && values) {
				return intl.formatMessage(descriptor, {
					...values,
					countries: typeof values.countries === 'string' ? replaceIds(values.countries) : values.countries,
					areas: typeof values.areas === 'string' ? replaceIds(values.areas) : values.areas,
				})
			}
			return intl.formatMessage(descriptor, values)
		}) as IntlShape['formatMessage'],
	}
}
